import listTemplate from 'emun.on-demand/media/od-media-manager.list.htm'
import gridTemplate from 'emun.on-demand/media/od-media-manager.grid.htm'
import headerTemplate from 'emun.on-demand/media/od-media-manager.header.htm'
import actionsTemplate from 'emun.on-demand/media/od-media-manager.actions.htm'
import resolve from 'ioc/resolve'
import MediaManagerDependentController from 'emun.on-demand/media/od-media-manager-dependent.controller'

let MediaManagerDependentComponent = {
    bindings: {
        media: '<?',
        type: '&'
    },
    require: {
        manager: '^odMediaManager'
    },
    controller: MediaManagerDependentController,
    templateUrl($element, $attrs) {
        if($attrs.templateUrl) return $attrs.templateUrl;
        else if($attrs.type === 'list') return listTemplate;
        else if($attrs.type === 'grid') return gridTemplate;
        else if($attrs.type === 'header') return headerTemplate;
        else return actionsTemplate;
    }
}

export default MediaManagerDependentComponent;
